import {searchPageAttributesMap, SearchPageType} from '../search/search-config';
import {HibuUiConfig, TagOptions} from './config-types';
import {configTagOptionLoaded, uiConfigLoaded} from './config-actions';
import {useDispatch} from 'react-redux';
import {useEffect} from 'react';
import {AbortCategory, fetchJson, postJsonWithBody} from '../services/fetcher';
import {HibuSearchResponse} from '../search/search-types';
import {Option} from '../common/select/select';
import createOption from '../common/select/hibuSelectUtil';
import {getCurrentLanguage} from '../i18n-service';
import {FacetValue, HibuFacetGroup} from '../facets/facet.types';
import {getContainerName} from '../settings/duck/settings-localstorage-service';

export const CONFIG_API_ENDPOINT = '/config';
export const UI_CONFIG_API_ENDPOINT = '/ui';

export async function fetchTagOptions(tags: string[], callback: (tagOptions: TagOptions) => void) {
    const requestBody = {displayLanguage: getCurrentLanguage(), facetFields: tags, container: getContainerName()};
    const serviceEndpoint = '/searchElementsValues';
    try {
        const data = await postJsonWithBody<HibuSearchResponse>(
            serviceEndpoint,
            JSON.stringify(requestBody),
            AbortCategory.MATA_INFO_OPTIONS,
        );
        const facetOptions: TagOptions =
            data?.facets?.reduce((result: TagOptions, facet: HibuFacetGroup) => {
                const facetShortName: string = facet.fieldName.split('.').pop() || '';
                result[facetShortName] = facet.values.reduce((list: Option[], val: FacetValue) => {
                    const name = createOption(val.value, val.name);
                    if (list.includes(name)) {
                        return list;
                    }
                    return [...list, name];
                }, []);

                return result;
            }, {}) || {};

        callback(facetOptions);
    } catch (error) {
        console.error('failed to fetch information dropdown options', error);
    }
}

export function useUiConfigRequest(): void {
    const dispatch = useDispatch();

    useEffect(() => {
        doConfigRequest(UI_CONFIG_API_ENDPOINT, AbortCategory.UI_CONFIG, false)
            .then((data: HibuUiConfig) => {
                const tags = data.search.tagsWithDropdown;
                dispatch(uiConfigLoaded(data));
                void fetchTagOptions(tags, (response) => dispatch(configTagOptionLoaded(response)));
            })
            .catch((error) => console.error('failed to fetch ui config', error));
    }, [dispatch]);
}

export const doConfigRequest = (path: string, abortCategory: AbortCategory, noAuth: boolean): Promise<any> => {
    return fetchJson<any>(
        searchPageAttributesMap[SearchPageType.BASIC].endpoint + CONFIG_API_ENDPOINT + path,
        'GET',
        abortCategory,
        noAuth
    );
};

